<template>
  <a href="#" class="project-card">
    <div v-if="project.attachments[0] !== undefined" class="project-card-image">
      <youtube v-if="project.attachments[0].mime_type === 'video/youtube'"
               :video-id="getIdFromURL(project.attachments[0].location)"
               class="video-player"
               player-width="100%"
               player-heigth="90%"
               host="https://www.youtube.com"
      ></youtube>
      <img v-else :src="project.attachments[0].location" class="w-full">
    </div>
    <div v-else class="project-card-image bg-black text-white text-2xl font-bold flex justify-center items-center">
      <p>{{ $t('projects.no-attachment') }}</p>
    </div>
    <h3 class="project-card-title">{{ project.name }}</h3>
    <p class="project-card-introduction">{{ project.introduction }}</p>
  </a>
</template>

<script>
import { getIdFromURL } from 'vue-youtube-embed'
export default {
  name: 'BaseProjectCard',
  props: {
    project: { type: Object }
  },
  methods: {
    getIdFromURL
  }

}
</script>

<style scoped>
.project-card {
  @apply rounded-md border border-black
    border-solid cursor-pointer;
  transition: all .5s linear;
  max-height: 500px;
  user-select: none;
  min-width: 300px;
}
.project-card:hover {
  @apply text-white bg-black;
}
.project-card-image {
  height: 300px;
  overflow: hidden;
}
.project-card-title {
  @apply text-center text-2xl;
  font-family: '8bit', sans-serif;
}
.project-card-introduction {
  @apply font-medium text-center;
}
.project-card-image > img {
  @apply rounded-md rounded-b-none;
  filter: grayscale(1);
  transition: filter .5s linear;
}
.project-card:hover > .project-card-image > img {
  filter: none;
}
.video-player {
  width:100% !important;
}
</style>
